import 'whatwg-fetch';

import { failureMsg } from './failure.js';
import { SCROLL_TO_DURATION, TRANSITION_DURATION } from './misc';
import { SHOW_QUESTIONS_EVENT } from './questions.js';
import { participantId, setParticipantId } from './gate.js';


var $ = require('jquery');
var Cookies = require('js-cookie/src/js.cookie');


export const GET_RESULTS_EVENT = 'ge-assessments:results:get-results';
const GET_RESULTS_ENDPOINT = 'results/';


function postResults(answers) {
    let $asmt = $('.asmt-container');
    let payload = {
        has_form: $asmt.data("asmt-has-form") !== undefined,
        participant_id: participantId,
        answers: answers
    };

    $asmt.find('.results-outer').show().scrollto(SCROLL_TO_DURATION);

    fetch(GET_RESULTS_ENDPOINT, {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': Cookies.get('csrftoken')
        },
        body: JSON.stringify(payload)
    })
    .then(
        function(response) {
            $asmt.find('.results-loading').hide();

            if (response.status !== 200) {
                return failureMsg();
            }

            response.json().then(function(json) {
                if (json.score_data === undefined) {
                    return failureMsg();
                }
                updateConclusion(json.score_data, $asmt);
                updateShareResults(json.social, $asmt);
                if (json.participant_id)
                {
                    setParticipantId(json.participant_id)
                }
            });
        }
    );
}


function updateConclusion(scoreData, $asmt) {
    let $container = $asmt.find('.conclusion-text-container');
    $container.find('.score-percentage').html(`${scoreData.score_percent.toString()}%`);
    $container.find('.conclusion-text').html(scoreData.conclusion_text);
    $asmt.find('.explanation-text').html(scoreData.explanation_text);
    $asmt.find('.results-conclusion').show().scrollto(SCROLL_TO_DURATION);
}


function updateShareResults(shareUrls, $asmt) {
    let $shareButtons = $asmt.find('.share-your-results a');
    for (let k in shareUrls) {
        $shareButtons.filter((_, e) => $(e).hasClass(k)).attr('href', shareUrls[k]);
    }
}


export function attachResultsEvents() {
    let $body = $('body');
    let $document = $(document);

    // listen for the event that kicks stuff off
    $document.on(GET_RESULTS_EVENT, function(event, data) {
        postResults(data.answers);
    });

    // take the assessment again
    $body.on('click', '.asmt-container .take-again', function() {
        $('.asmt-container .results-outer').slideUp(TRANSITION_DURATION);
        $('.asmt-container .asmt-form-outer').show();
        $document.trigger(SHOW_QUESTIONS_EVENT);
    });
}



// WEBPACK FOOTER //
// ./src/results.js